import { Box } from "@chakra-ui/react";
import { css } from "@emotion/react";
import { colors } from "goi_common";
import { ReactNode } from "react";
import { useRecoilState } from "recoil";
import {
  additionalTagsState,
  priceTagsState,
  processTagsState,
  sincerityTagsState,
} from "../../../../atoms/funeralReviewState";
import { newTagList } from "../../constants/tags";

function RecommendationTags() {
  return (
    <Box>
      <div css={subtitleCss} className="button2">
        📝 전문적인 진행
      </div>
      {newTagList["전문적인 진행"].map((tag) => {
        return (
          <RecommendationTagBox
            key={tag.description}
            icon={tag.icon}
            description={tag.description}
            recoilState={processTagsState}
            id={tag.id}
          />
        );
      })}
      <div css={subtitleCss} className="button2">
        ❤️ 진정성
      </div>
      {newTagList["진정성"].map((tag) => {
        return (
          <RecommendationTagBox
            key={tag.description}
            icon={tag.icon}
            description={tag.description}
            recoilState={sincerityTagsState}
            id={tag.id}
          />
        );
      })}
      <div css={subtitleCss} className="button2">
        💰 가격 만족도
      </div>
      {newTagList["가격 만족도"].map((tag) => {
        return (
          <RecommendationTagBox
            key={tag.description}
            icon={tag.icon}
            description={tag.description}
            recoilState={priceTagsState}
            id={tag.id}
          />
        );
      })}
      <div css={subtitleCss} className="button2">
        💰 추가금
      </div>
      {newTagList["추가금"].map((tag) => {
        return (
          <RecommendationTagBox
            key={tag.description}
            icon={tag.icon}
            description={tag.description}
            recoilState={additionalTagsState}
            id={tag.id}
          />
        );
      })}
    </Box>
  );
}

interface RecommendationTagBoxProps {
  icon: ReactNode;
  description: string;
  recoilState: any;
  id: number;
}
const RecommendationTagBox = ({
  icon,
  description,
  recoilState,
  id,
}: RecommendationTagBoxProps) => {
  const [selectedTags, setSelectedTags] = useRecoilState(recoilState);

  return (
    <Box
      onClick={() => setSelectedTags(id)}
      backgroundColor={selectedTags === id ? colors.orange650 : "white"}
      boxShadow="0px 0px 6px rgba(0, 0, 0, 0.06);"
      borderRadius="5px"
      padding="12px 16px"
      mb="8px"
      display="flex"
      minWidth="327px"
      cursor="pointer"
    >
      {icon}
      <Box
        ml="8px"
        className="gray900 body2"
        color={selectedTags === id ? "white" : colors.gray900}
      >
        {description}
      </Box>
    </Box>
  );
};
export default RecommendationTags;

const subtitleCss = css({
  margin: "24px 0px 12px",
});
